exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "div.footer {\r\n    background-color: #e7f0f7;\r\n    position: relative;\r\n    float: left;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n}", "", {"version":3,"sources":["D:/Entero/enterofieldforce/client/app/footer/footer.component.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,YAAY;CACf","file":"footer.component.css","sourcesContent":["div.footer {\r\n    background-color: #e7f0f7;\r\n    position: relative;\r\n    float: left;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);

// exports
